@if (this.payMethodList!=null) {

<div class="pay-method-editor">
    @if (fintechService.editMode != "billing") {
        <label class="header-label">Payment method:</label>
        <div class="horizontal-container">
            @if (showRecurringCard()) {
                <div class="vertical-container" style="width: 470px">
                    <div class="card-info-label">For Subscription:</div>
                    <app-fintech-pay-method-info #subscriptionPayMethod class="selected-pay-method-info" style="width: 400px">
                    </app-fintech-pay-method-info>
                    <button (click)="onReplaceCard('Subscription')" class="subButton" mat-raised-button [disabled]="fintechService.editMode!='info'">Replace card</button>
                </div>
            }
            @if (showPurchasesCard()) {
                <div class="vertical-container" style="width: 500px">
                    <div class="card-info-label">For Purchases:</div>
                    <app-fintech-pay-method-info #purchasesPayMethod class="selected-pay-method-info" style="width: 400px">
                    </app-fintech-pay-method-info>
                    <button (click)="onReplaceCard('Purchases')" class="subButton" mat-raised-button [disabled]="fintechService.editMode!='info'">Replace card</button>
                </div>
            }
        </div>
    }
    @if (fintechService.editMode == "billing") {
        <label class="header-label">{{selectionFor}} payment method:</label>
        <div class="horizontal-container" style="align-items: center; padding-top: 5px">
            <ngx-flicking #flk [options]=flickingOptions (ready)="onReady()" [ngStyle]="{'display': isFlickingVisible ? 'block' : 'none'}">
                <div flicking-panel *ngFor="let page of payMethodList" class="flicking-panel">
                    <div class="horizontal-container">
                        <div class="vertical-container">
                            @if (selectionFor == "Subscription") {
                                <mat-radio-group [(ngModel)]="recurringPayMethodId">
                                    <mat-radio-button [value]="page.payMethodId">selected</mat-radio-button>
                                </mat-radio-group>
                            }
                            @if (selectionFor == "Purchases") {
                                <mat-radio-group [(ngModel)]="orderPayMethodId">
                                    <mat-radio-button [value]="page.payMethodId">selected</mat-radio-button>
                                </mat-radio-group>
                            }
                        </div>
                        <button (click)="onPayMethodDelete(page.payMethodId)" class="subButton" mat-raised-button [disabled]="fintechService.busy"><mat-icon>delete</mat-icon>Delete card</button>
                    </div>
                    <app-fintech-pay-method-info  [payMethodInfo]="page" class="hand-cursor"></app-fintech-pay-method-info>
                </div>
            </ngx-flicking>


            <div class="vertical-container">
                <div class="add-button-container">
                    <button (click)="onAddPayMethod()" class="add-card-button" mat-raised-button [disabled]="fintechService.busy">Add</button>
                </div>
            </div>
        </div>
        <button (click)="onPayMethodUpdate()" class="subButton" mat-raised-button [disabled]="!canSelectPayMethod()">Select</button>
        <button (click)="onPayMethodCancel()" class="subButton" mat-raised-button [disabled]="fintechService.busy">Close</button>
    }
</div>
}
